export default "__VITE_ASSET__Ch7NnPJ6__"